import React from 'react'
import PropTypes from 'prop-types'

import MyCourseUnitList from './subcomponents/MyCourseUnitList/MyCourseUnitList'
import MyCourseSkeleton from './MyCourseSkeleton'

const MyCourse = ({
  units,
  onReorder,
  isEditMode,
  onRemove,
  currentCefrLevel,
}) => {
  return (
    <MyCourseSkeleton
      listSection={
        <MyCourseUnitList
          isEditMode={isEditMode}
          units={units}
          onReorder={onReorder}
          onRemove={onRemove}
          currentCefrLevel={currentCefrLevel}
        />
      }
    />
  )
}

MyCourse.propTypes = {
  units: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  onReorder: PropTypes.func,
  isEditMode: PropTypes.bool,
  onRemove: PropTypes.func,
  currentCefrLevel: PropTypes.string.isRequired,
}

export default MyCourse
